export default __webpack_public_path__ + "static/media/phone_footer_landing_page.532d84e2.svg";